module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"depot":"Depot","errorMessage":"Please select a depot"},"es":{"depot":"Estación de molienda","errorMessage":"Seleccione un depósito"},"sw":{"depot":"Mwanaume","errorMessage":"Tafadhali chagua bohari"}}')
  delete Component.options._Ctor
}
